import apiService from './api-service';

export const scfgService = {
    getUser,
    getUsers,
    createUser,
    updateUser,
    deleteUser,
    getSettings
};

async function getUser(userId) {
    const options = [
        {
            name: "userId",
            value: userId
        }
    ];

    const user = await apiService.get('scfg/getUser', options);
    return user;
}

async function getUsers() {
    const users = await apiService.get('scfg/getUsers');
    return users;
}

async function createUser(user) {
    const countInsertedRows = await apiService.post('scfg/createUser', user);
    return countInsertedRows;
}

async function updateUser(user) {
    const countUpdatedRows = await apiService.post('scfg/updateUser', user);
    return countUpdatedRows;
}

async function deleteUser(userId) {
    const user = { userId: userId };

    const countDeletedRows = await apiService.post('scfg/deleteUser', user);
    return countDeletedRows;
}

async function getSettings() {
    const settings = await apiService.get('scfg/getSettings');
    return settings;
}